const getRetention = (millisec) => {
    try {
        let seconds = Math.floor(millisec / 1000);
        let minutes = Math.floor(seconds / 60);
        let hours = Math.floor(minutes / 60);
        seconds %= 60;
        minutes = seconds >= 30 ? minutes + 1 : minutes;
        minutes %= 60;
        hours %= 24;
        return { hours, minutes };
    } catch (e) {
        return { hours: 0, minutes: 0 };
    }
};

const getTopicRetention = (retentionUnit, retentionDetails) => {
    let retentionValue = { retention: '', retentionUnit, retentionDetails };
    if (retentionUnit === 'In Days') {
        const getdays = retentionDetails?.millisec / (1000 * 60 * 60 * 24);
        retentionValue = { retention: getdays, retentionUnit, retentionDetails: { displayValue: getdays, millisec: retentionDetails?.millisec } };
    }
    if (retentionUnit === 'In Hours') {
        const hourMin = getRetention(retentionDetails?.millisec);
        retentionValue = {
            retentionUnit,
            retention: `${hourMin?.hours}:${hourMin?.minutes}`,
            retentionDetails: { displayValue: `${hourMin?.hours}:${hourMin?.minutes}`, millisec: retentionDetails?.millisec },
        };
    }
    return retentionValue;
};

export const formOrderObjFromCart = (data = null) => {
    const { itemDetail } = data || {};
    const { entityDetails, catalogService } = itemDetail || {};
    const { catalogConfig, catalogServiceCode, catalogType, cloudProvider, cloudService } = catalogService || {};
    const {
        environmentDetails,
        tags,
        topicName,
        retentionUnit,
        retentionPeriod,
        partitionCount,
        consumerGroup,
        consumerId,
        producerId,
        isTransactional,
        transactionPrincipalId,
        transactionPrefixText,
        ldapGroup,
        isReadAccessRequired,
    } = catalogConfig || {};

    const retention = getTopicRetention(retentionUnit, { displayValue: null, millisec: retentionPeriod });
    let readAccessRequiredValue = null;
    if (isReadAccessRequired === true) {
        readAccessRequiredValue = 'yes';
    } else if (isReadAccessRequired === false) {
        readAccessRequiredValue = 'no';
    }

    let readAccessUserValue = null;
    if (readAccessRequiredValue === 'yes') {
        readAccessUserValue = consumerId ? 'yes' : 'no';
    }

    return {
        appProfile: entityDetails?.name || null,
        applicationName: entityDetails?.name || null,
        sector: environmentDetails?.sector || null,
        environment: environmentDetails?.environment || null,
        region: environmentDetails?.region || null,
        appRegion: environmentDetails?.applicationRegion || null,
        department: environmentDetails?.department || null,
        businessUnit: environmentDetails?.businessUnit || null,
        businessUnitDetails: environmentDetails?.businessUnit ? { label: environmentDetails.businessUnit, value: environmentDetails.businessUnit } : null,
        hCode: environmentDetails?.costCenter || null,
        hCodeDetails: environmentDetails?.costCenter
            ? { label: environmentDetails.costCenter, value: environmentDetails.costCenter, projectName: environmentDetails.projectName }
            : null,
        isaDocument: environmentDetails?.isaDocument || null,
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        billingEntity: entityDetails?.billingEntity || null,
        project: catalogConfig?.project || null,
        cluster: catalogConfig?.cluster || null,
        clusterDetails: catalogConfig?.cluster ? { label: catalogConfig.cluster, value: catalogConfig.cluster } : null,
        catalogSize: catalogConfig?.size || null,
        catalogSizeDetails: catalogConfig?.size || null,
        appSupportMailId: catalogConfig?.appSupportMailId || null,
        topic: topicName || null,
        partitions: partitionCount || null,
        ...(ldapGroup && { ldap: ldapGroup }),
        isReadAccessRequired: readAccessRequiredValue,
        consumerGroupRadio: consumerGroup !== '' && consumerGroup !== null ? 'yes' : 'no',
        ...(consumerGroup && { consumerGroupList: consumerGroup.split(',').map((z) => ({ value: z })) }),
        isReadAccessUser: readAccessUserValue,
        readIDX: readAccessUserValue === 'yes' ? consumerId || null : null,
        isWriteAccessUser: producerId ? 'yes' : 'no',
        writeIDX: producerId || null,
        transactionalId: isTransactional ? 'yes' : 'no',
        ...(isTransactional && { transactionPrincipalId, transactionPrefixText }),
        retentionUnit: retention?.retentionUnit,
        retention: retention?.retention,
        retentionDetails: retention?.retentionDetails,
        tagsQc: { ...tags },
        entityDetails: { ...entityDetails },
        catalogCode: catalogServiceCode,
        catalogType,
        cloudProvider,
        cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null) => {
    const { entityDetails, catalogServices } = data || {};
    const catalog = catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || {};
    const { catalogConfig, catalogServiceCode, catalogType, cloudProvider, cloudService } = catalog || {};
    const {
        environmentDetails,
        tags,
        topicName,
        retentionUnit,
        retentionPeriod,
        partitionCount,
        consumerGroup,
        consumerId,
        producerId,
        isTransactional,
        transactionPrincipalId,
        transactionPrefixText,
        ldapGroup,
        isReadAccessRequired,
    } = catalogConfig || {};

    const getDetail = (value) => (value ? { label: value, value } : null);
    const retention = getTopicRetention(retentionUnit, { displayValue: null, millisec: retentionPeriod });

    let readAccessRequiredValue = null;
    if (isReadAccessRequired === true) {
        readAccessRequiredValue = 'yes';
    } else if (isReadAccessRequired === false) {
        readAccessRequiredValue = 'no';
    }

    let readAccessUserValue = null;
    if (readAccessRequiredValue === 'yes') {
        readAccessUserValue = consumerId ? 'yes' : 'no';
    }

    return {
        appProfile: entityDetails?.name || null,
        applicationName: entityDetails?.name || null,
        sector: environmentDetails?.sector || null,
        environment: environmentDetails?.environment || null,
        region: environmentDetails?.region || null,
        appRegion: environmentDetails?.applicationRegion || null,
        department: environmentDetails?.department || null,
        businessUnit: environmentDetails?.businessUnit || null,
        businessUnitDetails: getDetail(environmentDetails?.businessUnit),
        hCode: environmentDetails?.costCenter || null,
        hCodeDetails: environmentDetails?.costCenter
            ? { label: environmentDetails.costCenter, value: environmentDetails.costCenter, projectName: environmentDetails.projectName }
            : null,
        isaDocument: environmentDetails?.isaDocument || null,
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        billingEntity: entityDetails?.billingEntity || null,
        project: catalogConfig?.project || null,
        cluster: catalogConfig?.cluster || null,
        clusterDetails: getDetail(catalogConfig?.cluster),
        catalogSize: catalogConfig?.size || null,
        catalogSizeDetails: catalogConfig?.size || null,
        appSupportMailId: catalogConfig?.appSupportMailId || null,
        topic: topicName || null,
        partitions: partitionCount || null,
        ...(ldapGroup && { ldap: ldapGroup }),
        isReadAccessRequired: readAccessRequiredValue,
        consumerGroupRadio: consumerGroup !== '' && consumerGroup !== null ? 'yes' : 'no',
        consumerGroupList: consumerGroup ? consumerGroup.split(',').map((value) => ({ value })) : [{ value: '' }],
        isReadAccessUser: readAccessUserValue,
        readIDX: readAccessUserValue === 'yes' ? consumerId || null : null,
        isWriteAccessUser: producerId ? 'yes' : 'no',
        writeIDX: producerId || null,
        transactionalId: isTransactional ? 'yes' : 'no',
        ...(isTransactional && { transactionPrincipalId, transactionPrefixText }),
        retentionUnit: retention?.retentionUnit,
        retention: retention?.retention,
        retentionDetails: retention?.retentionDetails,
        tagsQc: { ...tags },
        entityDetails: { ...entityDetails },
        catalogCode: catalogServiceCode,
        catalogType,
        cloudProvider,
        cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};
export const resetOrder = {
    // Application Section
    applicationName: null,
    appShortName: null,
    appProfile: null,
    drPriority: null,
    entityDetails: null,
    sector: null,
    sectorDetails: null,
    appRegion: null,
    environment: null,
    regionDetails: null,
    hCode: null,
    hCodeDetails: null,
    appOwner: null,
    appOwnerDetails: null,
    appSupportMailId: null,
    billingEntity: null,
    billingEntityDetails: null,
    businessUnit: null,
    businessUnitDetails: null,
    isaDocument: null,
    ldap: null,

    // Resource Section
    awsAccount: null,
    awsAccountId: null,
    department: null,
    cluster: null,
    clusterDetails: null,
    project: null,
    catalogSize: null,
    catalogSizeDetails: null,

    // Kafka Topic Configuration Section
    topic: '',
    partitions: null,
    consumerGroupRadio: 'no',
    consumerGroupList: [{ value: '' }],
    isReadAccessRequired: null,
    isReadAccessUser: null,
    isWriteAccessUser: null,
    writeAccessGroupOwner: null,
    writeAccessGroupOwnerDetails: null,
    writeIDX: '',
    transactionalId: 'no',
    transactionPrefixText: '',
    transactionPrincipalId: '',
    retention: null,
    retentionUnit: 'In Days',
    retentionDetails: null,
    readAccessGroupOwner: null,
    readAccessGroupOwnerDetails: null,
    adGroupOwner: null,
    adGroupOwnerDetails: null,
    readIDX: '',

    catalogCode: null,

    tags: [],
    estimatedCost: {
        details: [],
        qty: null,
        totalOneTimeCost: {
            frequency: 'one time',
            estCost: null,
            currency: 'USD',
        },
        totalRecurringCost: {
            frequency: 'monthly',
            estCost: null,
            currency: 'USD',
        },
        notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
    },
    placeNewOrder: new Date(),
    validationStatus: 'clearValidation',
    isTouched: false,
};

export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
    isTagOpen: false,
    isApplicationOpen: false,
    isSubmitOrderSuccess: false,
    isUpdatedToCart: false,
    isCostSplitOpen: false,
    isConsumerGroupOpen: false,
};

export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: {
        frequency: 'one time',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'monthly',
        estCost: null,
        currency: 'USD',
    },
    notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
};

export const costPayload = ({ order = {}, catalogCode }) => ({
    catalogServiceCode: catalogCode,
    quantity: 1,
    catalogConfig: {
        cluster: order?.cluster || null,
        environment: order?.environment || null,
        region: order?.regionDetails?.region || order?.region || null,
        department: order?.department || null,
        awsAccountId: order?.awsAccountId || null,
    },
});
